import { Badge, Highlight, Table, Text } from '@mantine/core'
import dayjs from 'dayjs'
import { memo } from 'react'
import { DeviceLog } from '@/types/device'
import { DeviceLogLevelBadge } from './DeviceLogLevelBadge'

type DeploymentAppLogsRowProps = {
  log: DeviceLog
  searchTerm: string
  cameraLabel?: string
}

export const DeploymentAppLogsRow = memo(function DeploymentAppLogsRow({
  log,
  searchTerm,
  cameraLabel
}: DeploymentAppLogsRowProps) {
  return (
    <Table.Tr>
      <Table.Td>
        <Text size="xs" c="dimmed">
          {dayjs(log.timestamp).format('YYYY-MM-DD HH:mm:ss')}
        </Text>
      </Table.Td>

      <Table.Td>
        <DeviceLogLevelBadge level={log.level} />
      </Table.Td>

      {cameraLabel !== undefined && (
        <Table.Td>
          <Text size="xs">{cameraLabel}</Text>
        </Table.Td>
      )}

      <Table.Td>
        {log.log_tag && (
          <Badge variant="transparent" color="gray" size="xs">
            {log.log_tag}
          </Badge>
        )}
      </Table.Td>

      <Table.Td>
        <Highlight size="xs" highlight={searchTerm}>
          {log.message}
        </Highlight>
      </Table.Td>
    </Table.Tr>
  )
})
